<template>
	<div v-if="activeTab === 'receipts'" class="tables-container">
		<EpsonReceiptsTable @failed-fetch="handleFetchError" />
		<ApiscontrinoReceiptsTable @failed-fetch="handleFetchError" v-if="userStore.currBusiness && userStore.currBusiness.apiscontrino_id" />
		<DailyClosuresTable @failed-fetch="handleFetchError" />
	</div>
	<div v-else class="tables-container">
		<template v-if="hasApifattura">
			<BusinessToCustomerInvoicesTable document-type="invoice" @failed-fetch="handleFetchError" @credit-note-emitted="refreshCreditNotes" />
			<BusinessToCustomerInvoicesTable ref="credit-notes-table" document-type="credit_note" @failed-fetch="handleFetchError" />
			<SelfInvoicesTable @failed-fetch="handleFetchError" />
		</template>
		<div v-else class="apifattura-hint">
			<p>{{ getString('apifattura_connect_hint') }}</p>
			<AppButton :text="getString('go_to_settings')" outline small @click="$router.push('/config/settings/general')" />
		</div>
	</div>
</template>

<script>
import BusinessToCustomerInvoicesTable from "@/console-new/components/config/administration/BusinessToCustomerInvoicesTable.vue";
import SelfInvoicesTable from "@/console-new/components/config/administration/SelfInvoicesTable.vue";
import EpsonReceiptsTable from "@/console-new/components/config/administration/EpsonReceiptsTable.vue";
import ApiscontrinoReceiptsTable from "@/console-new/components/config/administration/ApiscontrinoReceiptsTable.vue";
import DailyClosuresTable from "@/console-new/components/config/administration/DailyClosuresTable.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {useUserStore} from "@/user/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";

// The tabs switch lives in the top navbar of ConfigContainer, the active tab in ?tab=
export const TAXATION_TABS = ['receipts', 'invoices'];

export function activeTaxationTab(route) {
	return TAXATION_TABS.includes(route.query.tab) ? route.query.tab : TAXATION_TABS[0];
}

export default {
	setup() {
		let userStore = useUserStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();

		return { userStore, getString: languageStore.getString, showNotification: notificationStore.showNotification };
	},
	name: "TaxationTablesContainer",
	components: {BusinessToCustomerInvoicesTable, SelfInvoicesTable, EpsonReceiptsTable, ApiscontrinoReceiptsTable, DailyClosuresTable, AppButton},
	computed: {
		activeTab() {
			return activeTaxationTab(this.$route);
		},
		hasApifattura() {
			return !!(this.userStore.currBusiness && this.userStore.currBusiness.apifattura_id);
		},
	},
	methods: {
		refreshCreditNotes() {
			if(this.$refs['credit-notes-table']) {
				this.$refs['credit-notes-table'].refresh();
			}
		},
		handleFetchError(details) {
			if(details && details !== 'not_connected') {
				let msg = details === 'auth_denied' ? 'auth-denied-error' : 'generic-fail';
				if(details === 'refund_limit_exceeded') {
					msg = 'refund-limit-exceeded-error';
				}
				this.showNotification(msg);
			}
		},
	},
	mounted() {
		if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
			this.userStore.getBusinessUsers();
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.userStore.getBusinessUsers();
			}
		}
	}
}
</script>

<style scoped lang="scss">
.tables-container {
	display: flex;
	flex-direction: column;
	gap: 30px;
}

.apifattura-hint {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 14px;
	padding: 40px 16px;
	text-align: center;
	color: var(--color-txt-2);
}
</style>
